webpackJsonp([1],{

/***/ "+Gxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__("/Put");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("Yhfl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/1Ne":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    MetaposeAPI: {
        BaseURL: 'https://uxcrd9tnsd.execute-api.us-east-1.amazonaws.com/Production',
        //        BaseURL:                    'http://localhost:3000',
        Version: '/v1',
        ProviderSignup: '/provider/signup',
        ProviderSignin: '/provider/signin',
        ProviderSignout: '/provider/signout',
        ProviderConfirm: '/provider/confirm',
        ProviderForgotPassword: '/provider/forgotpassword',
        ProviderConfirmPassword: '/provider/confirmpassword',
        ProviderResendConfirmation: '/provider/resendconfirmation',
        PatientSignup: '/patient/signup',
        PatientSignin: '/patient/signin',
        PatientSignout: '/patient/signout'
    }
});

/***/ }),

/***/ "/FRj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_js__ = __webpack_require__("DxRk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Login',
    data: function data() {
        return {
            needsConfirmation: false,
            hasError: false,
            errorMessage: '',
            form: {
                username: '',
                password: '',
                checked: false,
                selected: null,
                confirmationCode: '',
                users: __WEBPACK_IMPORTED_MODULE_0__user_js__["a" /* default */].UserEnum.properties
            }
        };
    },

    methods: {
        onSubmitSignin: onSubmitSignin,
        onSubmitConfirmation: onSubmitConfirmation,
        onResendConfirmation: onResendConfirmation,
        onForgotPassword: onForgotPassword
    },
    mounted: onMounted

    ////////////////////////////////////////////////////////////////////////////////
    //
    //
    //
});function onSubmitSignin(event) {
    this.needsConfirmation = false;
    this.hasError = false;
    this.errorMessage = '';

    signIn(this);
}

////////////////////////////////////////////////////////////////////////////////
//
//
//
function onForgotPassword(event) {
    switch (this.form.selected) {
        case __WEBPACK_IMPORTED_MODULE_0__user_js__["a" /* default */].UserEnum.PATIENT:
            this.$router.push('/patient/forgot-password');
            break;
        case __WEBPACK_IMPORTED_MODULE_0__user_js__["a" /* default */].UserEnum.PROVIDER:
            this.$router.push('/provider/forgot-password');
            break;
        default:
            break;
    }
}

////////////////////////////////////////////////////////////////////////////////
//
//
//
function onSubmitConfirmation(event) {
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_0__user_js__["a" /* default */].confirm(this.form.username, this.form.confirmationCode, this.form.selected, function successCallback() {
        signIn(_this);
    }, function failureCallback(error) {
        _this.hasError = true;
        _this.errorMessage = 'A confirmation error has occurred.';
        if (typeof error.response.data.Error.code !== 'undefined') {
            switch (error.response.data.Error.code) {
                case "UserNotConfirmedException":
                    _this.errorMessage = 'User needs to be confirmed.';
                    _this.needsConfirmation = true;
                    break;
            }
        }
    });
}

////////////////////////////////////////////////////////////////////////////////
//
//
//
function onResendConfirmation(event) {
    var _this = this;
    __WEBPACK_IMPORTED_MODULE_0__user_js__["a" /* default */].resendVerificationCode(this.form.username, this.form.selected, function successCallback() {
        _this.hasError = false;
        _this.errorMessage = '';
    }, function failureCallback(error) {
        _this.hasError = true;
        _this.errorMessage = 'An error occurred while attempting to resend a confirmation code.';
    });
}

////////////////////////////////////////////////////////////////////////////////
//
//
//
function signIn(component) {
    try {
        var recaptchaResponse = grecaptcha.getResponse(component.recaptchaID);
        if (recaptchaResponse.length === 0) {
            component.hasError = true;
            component.errorMessage = "Please verify that you're human.";
            return;
        }

        // CORS Issue
        // https://github.com/github/fetch/issues/386
        if (component.form.selected === null) {
            component.hasError = true;
            component.errorMessage = 'Please select a user type.';
            return;
        }

        var _this = this;
        __WEBPACK_IMPORTED_MODULE_0__user_js__["a" /* default */].signIn({
            username: component.form.username,
            password: component.form.password
        }, {
            recaptchaResponse: recaptchaResponse,
            userType: component.form.selected
        }, function successCallback() {
            component.hasError = false;
            component.errorMessage = '';
            component.$router.push(__WEBPACK_IMPORTED_MODULE_0__user_js__["a" /* default */].UserEnum.properties[component.form.selected].welcomePath);
        }, function failureCallback(error) {
            if (error != null && error.response != null && error.response.data != null && error.response.data.error != null && error.response.data.error.code != null && typeof error.response.data.error.code != 'undefined') {
                switch (error.response.data.error.code) {
                    case "UserNotConfirmedException":
                        if (__WEBPACK_IMPORTED_MODULE_0__user_js__["a" /* default */].UserEnum.properties[component.form.selected].value === __WEBPACK_IMPORTED_MODULE_0__user_js__["a" /* default */].UserEnum.PROVIDER) {
                            component.hasError = true;
                            component.errorMessage = 'User needs to be confirmed.';
                            component.needsConfirmation = true;
                        } else {
                            component.hasError = true;
                            component.errorMessage = 'Your account has not been confirmed. Please contact the help desk.';
                        }
                        break;
                    default:
                        component.hasError = true;
                        component.errorMessage = 'An error has occurred while attempting to sign in.';
                        break;
                }
            } else {
                component.hasError = true;
                component.errorMessage = 'An error has occurred while attempting to sign in.';
            }
        });
    } catch (error) {
        alert('Signin Exception: ' + error);
    }
}

////////////////////////////////////////////////////////////////////////////////
//
//
//
function onMounted() {
    this.recaptchaID = grecaptcha.render("signin-recaptcha", {
        sitekey: "6LdxaU0UAAAAAB9Dy583J6VbH4BNn8PTvvk9ikJ9"
    });
}

/***/ }),

/***/ "/Put":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__("fnDg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */]);

/***/ }),

/***/ "/Wdj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'WelcomeProvider',
    data: function data() {
        return {
            message: "Welcome Provider " + this.$store.state.user.longUsername
        };
    },

    computed: {}
});

/***/ }),

/***/ "0T8p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "23sU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_patient_welcome_vue__ = __webpack_require__("C8O4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea6bb6b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_patient_welcome_vue__ = __webpack_require__("e6KS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_patient_welcome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea6bb6b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_patient_welcome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "C8O4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'WelcomePatient',
    data: function data() {
        return {
            message: "Welcome Patient " + this.$store.state.user.username
        };
    }
});

/***/ }),

/***/ "DxRk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__("u2KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode__ = __webpack_require__("ytdl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configuration_js__ = __webpack_require__("/1Ne");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_js__ = __webpack_require__("olkN");








var User = {
    UserEnum: {
        NONE: null,
        PATIENT: 1,
        PROVIDER: 2,
        properties: [{
            text: "Select One",
            value: null,
            welcomePath: ""
        }, {
            text: "Patient",
            value: 1,
            welcomePath: "/patient/welcome"
        }, {
            text: "Provider",
            value: 2,
            welcomePath: "/provider/welcome"
        }]
    },
    getLongUsername: function getLongUsername() {
        var userInfo = __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.getJSON('meta-user');
        var name = '';

        if (userInfo != null && userInfo.tokens != null && userInfo.tokens.idToken != null) {
            var idToken = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(userInfo.tokens.idToken);
            if (idToken != null) {
                if (userInfo.type.toLowerCase() === "provider") name = idToken.given_name + ' ' + idToken.family_name;else if (userInfo.type.toLowerCase() === "patient") name = idToken.username;
            }
        }

        return name;
    },
    getUsername: function getUsername() {
        var userInfo = __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.getJSON('meta-user');
        var name = '';

        if (userInfo != null && userInfo.tokens != null && userInfo.tokens.idToken != null) {
            var idToken = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(userInfo.tokens.idToken);
            if (idToken != null) {
                if (userInfo.type.toLowerCase() === "provider") name = idToken.email;else if (userInfo.type.toLowerCase() === "patient") name = idToken.username;
            }
        }

        return name;
    },
    isAuthenticated: function isAuthenticated() {
        var userInfo = __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.getJSON('meta-user');
        if (userInfo == null || userInfo.tokens == null || userInfo.tokens.accessToken == null) return false;

        var access = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(userInfo.tokens.accessToken);
        var now = new Date();
        if (now.getMilliseconds() >= access.exp) return false;

        return true;
    },
    getUserType: function getUserType() {
        var userInfo = __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.getJSON('meta-user');
        if (userInfo == null) return "";

        return userInfo.type;
    },
    signUp: function signUp(credentials, parameters, successCallback, failureCallback) {
        var url = __WEBPACK_IMPORTED_MODULE_5__configuration_js__["a" /* default */].MetaposeAPI.BaseURL + __WEBPACK_IMPORTED_MODULE_5__configuration_js__["a" /* default */].MetaposeAPI.Version + '/' + this.UserEnum.properties[parameters.userType].text.toLowerCase() + '/signup';

        var requestParams = {};
        if (parameters.userType === this.UserEnum.PATIENT) {
            requestParams = {
                attributes: parameters.attributes,
                recaptchaResponse: parameters.recaptchaResponse
            };
        } else if (parameters.userType === this.UserEnum.PROVIDER) {
            requestParams = {
                username: credentials.username,
                password: credentials.password,
                attributes: parameters.attributes
            };
        }

        try {
            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url, requestParams, {
                withCredentials: true
            }).then(function (response) {
                var result = { username: response.data.username, password: response.data.password };

                if (successCallback != null) successCallback(result);
            }).catch(function (error) {
                if (failureCallback != null) failureCallback(error);
            });
        } catch (error) {
            alert('User Signin Exception: ' + error);
        }
    },
    signIn: function signIn(credentials, parameters, successCallback, failureCallback) {
        var _this = this;
        var url = __WEBPACK_IMPORTED_MODULE_5__configuration_js__["a" /* default */].MetaposeAPI.BaseURL + __WEBPACK_IMPORTED_MODULE_5__configuration_js__["a" /* default */].MetaposeAPI.Version + '/' + this.UserEnum.properties[parameters.userType].text.toLowerCase() + '/signin';
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url, {
            recaptchaResponse: parameters.recaptchaResponse
        }, {
            auth: { username: credentials.username, password: credentials.password },
            withCredentials: true
        }).then(function (response) {
            var tokens = response.data.tokens;
            var userType = _this.UserEnum.properties[parameters.userType];

            __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.set('meta-user', { tokens: tokens, type: userType.text });

            __WEBPACK_IMPORTED_MODULE_6__store_js__["a" /* default */].state.user.isAuthenticated = true;
            __WEBPACK_IMPORTED_MODULE_6__store_js__["a" /* default */].state.user.longUsername = _this.getLongUsername();
            __WEBPACK_IMPORTED_MODULE_6__store_js__["a" /* default */].state.user.username = _this.getUsername();

            if (successCallback != null) successCallback();
        }).catch(function (error) {
            if (failureCallback != null) failureCallback(error);
        });
    },
    signOut: function signOut(successCallback, failureCallback) {
        __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.remove('meta-user');
        __WEBPACK_IMPORTED_MODULE_6__store_js__["a" /* default */].state.user.isAuthenticated = false;
        __WEBPACK_IMPORTED_MODULE_6__store_js__["a" /* default */].state.user.longUsername = null;
        __WEBPACK_IMPORTED_MODULE_6__store_js__["a" /* default */].state.user.username = null;

        if (successCallback != null) successCallback();
    },
    confirm: function confirm(username, confirmationCode, type, successCallback, failureCallback) {
        if (type != this.UserEnum.PROVIDER) {
            failureCallback('Invalid user type.');
            return;
        }

        var url = __WEBPACK_IMPORTED_MODULE_5__configuration_js__["a" /* default */].MetaposeAPI.BaseURL + __WEBPACK_IMPORTED_MODULE_5__configuration_js__["a" /* default */].MetaposeAPI.Version + '/' + this.UserEnum.properties[type].text.toLowerCase() + '/confirm';

        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url, {
            username: username,
            confirmation_code: confirmationCode
        }, {}).then(function (response) {
            if (successCallback != null) successCallback();
        }).catch(function (error) {
            if (failureCallback != null) failureCallback(error);
        });
    },
    forgotPassword: function forgotPassword(username, type, successCallback, failureCallback) {
        if (type != this.UserEnum.PROVIDER) {
            failureCallback('Invalid user type.');
            return;
        }

        var url = __WEBPACK_IMPORTED_MODULE_5__configuration_js__["a" /* default */].MetaposeAPI.BaseURL + __WEBPACK_IMPORTED_MODULE_5__configuration_js__["a" /* default */].MetaposeAPI.Version + '/' + this.UserEnum.properties[type].text.toLowerCase() + '/forgotpassword';

        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url, {
            username: username
        }, {}).then(function (response) {
            if (successCallback != null) successCallback();
        }).catch(function (error) {
            if (failureCallback != null) failureCallback(error);
        });
    },
    resendVerificationCode: function resendVerificationCode(username, type, successCallback, failureCallback) {
        if (type != this.UserEnum.PROVIDER) {
            failureCallback('Invalid user type.');
            return;
        }

        var url = __WEBPACK_IMPORTED_MODULE_5__configuration_js__["a" /* default */].MetaposeAPI.BaseURL + __WEBPACK_IMPORTED_MODULE_5__configuration_js__["a" /* default */].MetaposeAPI.Version + '/' + this.UserEnum.properties[type].text.toLowerCase() + '/resendconfirmation';

        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url, {
            username: username
        }).then(function (response) {
            if (successCallback != null) successCallback();
        }).catch(function (error) {
            if (failureCallback != null) failureCallback(error);
        });
    },
    confirmPassword: function confirmPassword(username, password, verficationCode, type, successCallback, failureCallback) {
        if (type != this.UserEnum.PROVIDER) {
            failureCallback('Invalid user type.');
            return;
        }

        var url = __WEBPACK_IMPORTED_MODULE_5__configuration_js__["a" /* default */].MetaposeAPI.BaseURL + __WEBPACK_IMPORTED_MODULE_5__configuration_js__["a" /* default */].MetaposeAPI.Version + '/' + this.UserEnum.properties[type].text.toLowerCase() + '/confirmpassword';

        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url, {
            username: username,
            password: password,
            verification_code: verficationCode
        }, {}).then(function (response) {
            if (successCallback != null) successCallback();
        }).catch(function (error) {
            if (failureCallback != null) failureCallback(error);
        });
    },
    changePassword: function changePassword(type, oldPassword, newPassword, successCallback, failureCallback) {
        if (type != this.UserEnum.PROVIDER) {
            failureCallback('Invalid user type.');
            return;
        }

        var url = __WEBPACK_IMPORTED_MODULE_5__configuration_js__["a" /* default */].MetaposeAPI.BaseURL + __WEBPACK_IMPORTED_MODULE_5__configuration_js__["a" /* default */].MetaposeAPI.Version + '/' + this.UserEnum.properties[type].text.toLowerCase() + '/changepassword';

        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(url, {
            old_password: oldPassword,
            new_password: newPassword
        }, {}).then(function (response) {
            if (successCallback != null) successCallback();
        }).catch(function (error) {
            if (failureCallback != null) failureCallback(error);
        });
    }
};

__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(User);
/* harmony default export */ __webpack_exports__["a"] = (User);

/***/ }),

/***/ "FGQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Home',
    data: function data() {
        return {
            message: "Home"
        };
    }
});

/***/ }),

/***/ "GCzh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'MetaposeMainMenu',
    data: function data() {
        return {};
    },

    methods: {
        signout: onSignout
    },
    computed: {
        isAuthenticated: function isAuthenticated() {
            return this.$store.state.user.isAuthenticated;
        },
        longUsername: function longUsername() {
            return this.$store.state.user.longUsername;
        }
    },
    beforeCreate: onBeforeCreate,
    beforeUpdate: onBeforeUpdate,
    updated: onUpdated

    ////////////////////////////////////////////////////////////////////////////////
    //
    //
    //
});function onSignout(event) {
    var _this = this;
    this.$user.signOut(function successCallback() {
        _this.$router.push('/');
    }, function failureCallback(error) {});
}

////////////////////////////////////////////////////////////////////////////////
//
//
//
function onBeforeCreate() {
    console.log('main-menu onBeforeCreate');
}

////////////////////////////////////////////////////////////////////////////////
//
//
//
function onBeforeUpdate() {
    console.log('main-menu onBeforeUpdate');
}

////////////////////////////////////////////////////////////////////////////////
//
//
//
function onUpdated() {
    console.log('main-menu onUpdated');
}

/***/ }),

/***/ "GIVX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gze5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__("XILU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_js__ = __webpack_require__("DxRk");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Patient-Signup',
    components: {
        DatePicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker___default.a
    },
    data: function data() {
        return {
            signedUp: false,
            user: {
                username: '',
                password: ''
            },
            form: {
                viewPassword: false,
                selectedGender: null,
                selectedBirthday: null,
                genders: [{ value: null, text: "Select one" }, { value: 0, text: "Male" }, { value: 1, text: "Female" }]
            }
        };
    },

    methods: {
        onSubmit: onSubmit
    },
    mounted: onMounted

    ////////////////////////////////////////////////////////////////////////////////
    //
    //
    //
});function onSubmit(event) {
    var recaptchaResponse = grecaptcha.getResponse(this.recaptchaID);
    if (recaptchaResponse.length === 0) {
        alert("Please verify that you're a human");
        return;
    }

    var _this = this;
    var birthday = __WEBPACK_IMPORTED_MODULE_2_moment___default()(this.form.selectedBirthday).format("MM/DD/YYYY");
    var gender = _this.form.genders[_this.form.selectedGender + 1].text;
    __WEBPACK_IMPORTED_MODULE_3__user_js__["a" /* default */].signUp(null, {
        recaptchaResponse: recaptchaResponse,
        userType: __WEBPACK_IMPORTED_MODULE_3__user_js__["a" /* default */].UserEnum.PATIENT,
        attributes: [{
            "key": "gender",
            "value": gender
        }, {
            "key": "birthdate",
            "value": birthday
        }]
    }, function successCallback(result) {
        _this.user.username = result.username;
        _this.user.password = result.password;
        _this.signedUp = true;
    }, function failureCallback(error) {
        console.log("onSubmit Failure: " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        if (error.response) alert('Failure ' + error.response.message);else if (error.message) alert('Failure ' + error.message);else alert('Failure ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
    });
}

////////////////////////////////////////////////////////////////////////////////
//
//
//
function onMounted() {
    this.recaptchaID = grecaptcha.render("patient-recaptcha", {
        sitekey: "6LdxaU0UAAAAAB9Dy583J6VbH4BNn8PTvvk9ikJ9"
    });
}

/***/ }),

/***/ "HUt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__("fcFS");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("hs8C")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HzZp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JCpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__("aPSQ");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("GIVX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JDVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__ = __webpack_require__("kJiG");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("HzZp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Jc/f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_provider_change_password_vue__ = __webpack_require__("Wzh3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a89c386_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_provider_change_password_vue__ = __webpack_require__("tSoY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_provider_change_password_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a89c386_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_provider_change_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JzNn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_patient_forgot_password_vue__ = __webpack_require__("US6a");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47408998_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_patient_forgot_password_vue__ = __webpack_require__("fkJA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_patient_forgot_password_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47408998_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_patient_forgot_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__("e6fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__application__ = __webpack_require__("rXWU");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#application',
    template: '<Application/>',
    components: {
        Application: __WEBPACK_IMPORTED_MODULE_3__application__["a" /* default */],
        BootstrapVue: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */],
        BabelPolyfill: __WEBPACK_IMPORTED_MODULE_2_babel_polyfill___default.a
    }
});

/***/ }),

/***/ "NjTB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_menu_vue__ = __webpack_require__("GCzh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_507b3551_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_menu_vue__ = __webpack_require__("Nool");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_main_menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_507b3551_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_main_menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Nool":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metapose-main-menu"},[_c('link',{attrs:{"type":"text/css","rel":"stylesheet","href":"//unpkg.com/bootstrap/dist/css/bootstrap.min.css"}}),_vm._v(" "),_c('link',{attrs:{"type":"text/css","rel":"stylesheet","href":"//unpkg.com/bootstrap-vue@1.5.0/dist/bootstrap-vue.css"}}),_vm._v(" "),_c('b-navbar',{attrs:{"id":"metapose-main-navbar","toggleable":"md","type":"dark","variant":"info"}},[_c('b-nav-toggle',{attrs:{"target":"nav_collapse"}}),_vm._v(" "),_c('b-navbar-brand',{attrs:{"to":"/"}},[_vm._v("Metapose")]),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"nav_collapse"}},[_c('b-nav',{staticClass:"mr-auto",attrs:{"is-nav-bar":""}},[_c('b-nav-item',{attrs:{"to":"/About"}},[_vm._v("About")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/Contact"}},[_vm._v("Contact")])],1),_vm._v(" "),_c('b-nav',{attrs:{"is-nav-bar":""}},[(_vm.isAuthenticated === false)?_c('b-nav-item',{attrs:{"to":"/account/signin"}},[_vm._v("Signin")]):_c('b-nav-item-dropdown',{attrs:{"text":_vm.longUsername}},[_c('b-dropdown-item',{on:{"click":function($event){_vm.signout()}}},[_vm._v("Signout")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OB4M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_provider_welcome_vue__ = __webpack_require__("/Wdj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4870824_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_provider_welcome_vue__ = __webpack_require__("olo0");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_provider_welcome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4870824_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_provider_welcome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P+mO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_provider_signup_vue__ = __webpack_require__("vTH8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1def4fb2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_provider_signup_vue__ = __webpack_require__("YR6+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_provider_signup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1def4fb2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_provider_signup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QY81":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signup-page"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-container',[_c('b-row',{attrs:{"align-h":"center"}},[_c('h1',[_vm._v("Signup")])]),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"id":"login-usertype-group","label-for":"login-usertype-select","label":"User Type:"}},[_c('b-form-select',{attrs:{"id":"login-usertype-select","options":_vm.form.users},nativeOn:{"input":function($event){return _vm.userTypeChange($event)}},model:{value:(_vm.form.selected),callback:function ($$v) {_vm.$set(_vm.form, "selected", $$v)},expression:"form.selected"}})],1)],1)],1)],1),_vm._v(" "),(_vm.form.selected === 0)?_c('patient-signup'):(_vm.form.selected === 1)?_c('provider-signup'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S4JM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contact_vue__ = __webpack_require__("bBBi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c494d3d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_vue__ = __webpack_require__("zjWa");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c494d3d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UJfa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'About',
    data: function data() {
        return {
            message: "About me"
        };
    }
});

/***/ }),

/***/ "UM4S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.signedUp)?_c('div',{staticClass:"patient-signup-page"},[_c('b-form',{on:{"submit":_vm.onSubmit}},[_c('b-container',[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"id":"patient-gender-group","label-for":"patient-gender-select","label":"Gender:"}},[_c('b-form-select',{attrs:{"id":"patient-gender-select","options":_vm.form.genders},model:{value:(_vm.form.selectedGender),callback:function ($$v) {_vm.$set(_vm.form, "selectedGender", $$v)},expression:"form.selectedGender"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"id":"patient-birthday-group","label-for":"patient-birthday-datepicker","label":"Birthday:"}},[_c('date-picker',{attrs:{"id":"patient-birthday-datepicker","placeholder":"Select Birthday","bootstrapStyling":true},model:{value:(_vm.form.selectedBirthday),callback:function ($$v) {_vm.$set(_vm.form, "selectedBirthday", $$v)},expression:"form.selectedBirthday"}})],1)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v("Submit")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('b-container',[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('div',{staticClass:"g-recaptcha",attrs:{"id":"patient-recaptcha","data-sitekey":"process.env.RECAPTCHA_SITE_KEY"}})])],1)],1)],1)],1):_c('div',[_c('b-container',[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('p',[_vm._v("\n                    You're signed up. Please note both the username and password \n                    and keep them in a safe place. If the password is lost, we \n                    are unable to recover it.\n                ")])])],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"1"}},[_vm._v("\n                Username:    \n            ")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[_c('b',[_vm._v(_vm._s(_vm.user.username))])])],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"1"}},[_vm._v("\n                Password:\n            ")]),_vm._v(" "),_c('b-col',{attrs:{"cols":"1"}},[(_vm.form.viewPassword)?_c('b',[_vm._v(_vm._s(_vm.user.password))]):_vm._e()])],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"2"}},[_c('b-form-checkbox',{model:{value:(_vm.form.viewPassword),callback:function ($$v) {_vm.$set(_vm.form, "viewPassword", $$v)},expression:"form.viewPassword"}},[_vm._v("View Password")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "US6a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Patient-Forgot-Password',
    data: function data() {
        return {
            message: "Please contact customer support with your ID in order to have a new password issued."
        };
    }
});

/***/ }),

/***/ "Vo8g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"provider-forgot-password-page"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-form',{on:{"submit":_vm.onSubmitForgotPassword}},[_c('b-container',[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('h2',[_vm._v("Provider Forgot Password")])])],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"id":"forgot-password-username-group","label-for":"forgot-password-username-input","label":"Username:"}},[_c('b-form-input',{attrs:{"id":"forgot-password-username-input","type":"text","placeholder":"Enter Username"},model:{value:(_vm.form.username),callback:function ($$v) {_vm.$set(_vm.form, "username", $$v)},expression:"form.username"}})],1)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"id":"forgot-password-verification-code-group","label-for":"forgot-password-verification-code-input","label":"Verification Code:"}},[_c('b-form-input',{attrs:{"id":"forgot-password-verification-code-input","type":"text","placeholder":"Verification Code"},model:{value:(_vm.form.verficationCode),callback:function ($$v) {_vm.$set(_vm.form, "verficationCode", $$v)},expression:"form.verficationCode"}})],1)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"id":"forgot-password-password-group","label-for":"forgot-password-password-input","label":"Password:"}},[_c('b-form-input',{attrs:{"id":"forgot-password-password-input","type":"password","placeholder":"Password"},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", $$v)},expression:"form.password"}})],1)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"id":"forgot-password-confirm-password-group","label-for":"forgot-password-confirm-password-input","label":"Confirm Password:"}},[_c('b-form-input',{attrs:{"id":"forgot-password-confirm-password-input","type":"password","placeholder":"Confirm Password"},model:{value:(_vm.form.confirmPassword),callback:function ($$v) {_vm.$set(_vm.form, "confirmPassword", $$v)},expression:"form.confirmPassword"}})],1)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-button',{attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.onSendVerificationCode}},[_vm._v("Send Verfication Code")]),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v("Submit")])],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_vm._v("\n                    "+_vm._s(_vm.message)+"\n                ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WiWv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__patient_patient_signup__ = __webpack_require__("bdw3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__provider_provider_signup__ = __webpack_require__("P+mO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Signup',
    components: {
        PatientSignup: __WEBPACK_IMPORTED_MODULE_0__patient_patient_signup__["a" /* default */],
        ProviderSignup: __WEBPACK_IMPORTED_MODULE_1__provider_provider_signup__["a" /* default */]
    },
    data: function data() {
        return {
            form: {
                selected: null,
                users: [{ value: null, text: "Select one" }, { value: 0, text: "Patient" }, { value: 1, text: "Provider" }]
            }
        };
    },

    methods: {
        userTypeChange: function userTypeChange(event) {
            var selected = this.$data.form.selected;
        }
    }
});

/***/ }),

/***/ "Wzh3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_js__ = __webpack_require__("DxRk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Provider-Change-Password',
    data: function data() {
        return {
            message: "",
            form: {
                oldPassword: "",
                newPassword: "",
                confirmNewPassword: ""
            }
        };
    },

    methods: {
        onSubmitForgotPassword: onSubmitForgotPassword
    }

    ////////////////////////////////////////////////////////////////////////////////
    //
    //
    //
});function onSubmitForgotPassword(event) {
    var _this = this;
    var hasError = false;
    if (this.form.newPassword === undefined || this.form.newPassword.length <= 0) {
        this.message = "Please fill out new password\n";
        hasError = true;
    }

    if (this.form.newPassword !== this.form.confirmNewPassword) {
        this.message = "The new passwords do not match.";
        hasError = true;
    }

    if (hasError) return;

    __WEBPACK_IMPORTED_MODULE_0__user_js__["a" /* default */].confirmPassword(this.form.username, this.form.oldPassword, this.form.newPassword, __WEBPACK_IMPORTED_MODULE_0__user_js__["a" /* default */].UserEnum.PROVIDER, function successCallback() {
        _this.$router.back();
    }, function failureCallback(error) {
        _this.message = "An error occurred attempting to update the provider password. Verify the password has at least one letter, one number and a character";
    });
}

/***/ }),

/***/ "XqEi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signup_vue__ = __webpack_require__("WiWv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40b05c2f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signup_vue__ = __webpack_require__("QY81");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40b05c2f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YR6+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.signedUp)?_c('div',{staticClass:"provider-signup-page"},[_c('b-form',{on:{"submit":_vm.onSubmit}},[_c('b-container',[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"id":"provider-given-name-group","label-for":"provider-given-name-input","label":"Given name:"}},[_c('b-form-input',{attrs:{"id":"provider-given-name-input","type":"text","placeholder":"Given Name"},model:{value:(_vm.form.givenName),callback:function ($$v) {_vm.$set(_vm.form, "givenName", $$v)},expression:"form.givenName"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"id":"provider-family-name-group","label-for":"provider-family-name-input","label":"Family name:"}},[_c('b-form-input',{attrs:{"id":"provider-family-name-input","type":"text","placeholder":"Family Name"},model:{value:(_vm.form.familyName),callback:function ($$v) {_vm.$set(_vm.form, "familyName", $$v)},expression:"form.familyName"}})],1)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"id":"provider-country-group","label-for":"provider-country-select","label":"Country:"}},[_c('b-form-select',{attrs:{"id":"provider-country-select","options":_vm.form.countries},model:{value:(_vm.form.selectedCountry),callback:function ($$v) {_vm.$set(_vm.form, "selectedCountry", $$v)},expression:"form.selectedCountry"}})],1)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"id":"provider-company-group","label-for":"provider-company-input","label":"Company Name:"}},[_c('b-form-input',{attrs:{"id":"provider-company-input","type":"text","placeholder":"Company"},model:{value:(_vm.form.companyName),callback:function ($$v) {_vm.$set(_vm.form, "companyName", $$v)},expression:"form.companyName"}})],1)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"id":"provider-email-group","label-for":"provider-email-input","label":"Email:"}},[_c('b-form-input',{attrs:{"id":"provider-email-input","type":"text","placeholder":"Email"},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"id":"provider-phone-group","label-for":"provider-phone-input","label":"Phone:"}},[_c('b-form-input',{attrs:{"id":"provider-phone-input","type":"text","placeholder":"Phone"},model:{value:(_vm.form.phone),callback:function ($$v) {_vm.$set(_vm.form, "phone", $$v)},expression:"form.phone"}})],1)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"id":"provider-password-group","label-for":"provider-password-input","label":"Password:"}},[_c('b-form-input',{attrs:{"id":"provider-password-input","type":"password","placeholder":"Password"},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", $$v)},expression:"form.password"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b-form-group',{attrs:{"id":"provider-confirm-password-group","label-for":"provider-confirm-password-input","label":"Confirm Password:"}},[_c('b-form-input',{attrs:{"id":"provider-confirm-password-input","type":"password","placeholder":"Confirm Password"}})],1)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('div',{staticClass:"g-recaptcha",attrs:{"data-sitekey":"process.env.RECAPTCHA_SITE_KEY"}}),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v("Submit")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('b-container',[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('div',{staticClass:"g-recaptcha",attrs:{"id":"provider-recaptcha","data-sitekey":"process.env.RECAPTCHA_SITE_KEY"}})])],1)],1)],1)],1):_c('div',[_c('b-container',[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('p',[_vm._v("\n                    You're signed up. Please continue to the sign in page.\n                ")])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Yhfl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aPSQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__("rKsW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__modal__["a" /* default */]);

/***/ }),

/***/ "adTx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-page"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-form',{on:{"submit":_vm.onSubmitSignin}},[_c('b-container',[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"id":"login-usertype-group","label-for":"login-usertype-select","label":"User Type:"}},[_c('b-form-select',{attrs:{"id":"login-usertype-select","options":_vm.form.users},model:{value:(_vm.form.selected),callback:function ($$v) {_vm.$set(_vm.form, "selected", $$v)},expression:"form.selected"}})],1)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"id":"login-username-group","label-for":"login-username-input","label":"Username:"}},[_c('b-form-input',{attrs:{"id":"login-username-input","type":"text","placeholder":"Enter Username"},model:{value:(_vm.form.username),callback:function ($$v) {_vm.$set(_vm.form, "username", $$v)},expression:"form.username"}})],1)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"id":"login-password-group","label-for":"login-password-input","label":"Password:"}},[_c('b-form-input',{attrs:{"id":"login-password-input","type":"password","placeholder":"Enter Password"},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", $$v)},expression:"form.password"}})],1)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"id":"login-remember-group"}},[_c('b-form-checkbox',{attrs:{"id":"login-remember-input"}},[_vm._v("Remember Me")])],1)],1)],1),_vm._v(" "),(_vm.hasError)?_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('span',[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),_c('br')])],1):_vm._e(),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v("Submit")]),_vm._v(" "),_c('b-link',{on:{"click":_vm.onForgotPassword}},[_vm._v("Forgot password?")])],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('span',[_vm._v("Get started - ")]),_c('b-link',{attrs:{"to":"/account/signup"}},[_vm._v("Signup")])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('b-container',[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('div',{staticClass:"g-recaptcha",attrs:{"id":"signin-recaptcha","data-sitekey":"process.env.RECAPTCHA_SITE_KEY"}})])],1)],1)],1),_vm._v(" "),(_vm.needsConfirmation === true)?_c('b-form',{on:{"submit":_vm.onSubmitConfirmation}},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-container',[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"id":"login-confirmation-group","label-for":"login-confirmation-select","label":"Confirmation:"}},[_c('b-form-input',{attrs:{"id":"login-confirmation-input","type":"text","placeholder":"Enter Confirmation Code"},model:{value:(_vm.form.confirmationCode),callback:function ($$v) {_vm.$set(_vm.form, "confirmationCode", $$v)},expression:"form.confirmationCode"}})],1)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v("Submit")]),_vm._v(" "),_c('b-button',{attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.onResendConfirmation}},[_vm._v("Resend")])],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bBBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Contact',
    data: function data() {
        return {
            message: "Contacts"
        };
    }
});

/***/ }),

/***/ "bGp9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page"},[_c('h1',[_vm._v("Home")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bdw3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_patient_signup_vue__ = __webpack_require__("Gze5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_624561bb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_patient_signup_vue__ = __webpack_require__("UM4S");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_patient_signup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_624561bb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_patient_signup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cHtD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode__ = __webpack_require__("ytdl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_js__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_home__ = __webpack_require__("wUZA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_about__ = __webpack_require__("zRCK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_contact__ = __webpack_require__("S4JM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_account_signin__ = __webpack_require__("xcyk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_account_signup__ = __webpack_require__("XqEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_patient_patient_welcome__ = __webpack_require__("23sU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_patient_patient_forgot_password__ = __webpack_require__("JzNn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_provider_provider_welcome__ = __webpack_require__("OB4M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_provider_provider_forgot_password__ = __webpack_require__("lDJJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_provider_provider_change_password__ = __webpack_require__("Jc/f");






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

//////////////////////
// Route Components //
//////////////////////












var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        name: 'HOme',
        component: __WEBPACK_IMPORTED_MODULE_5__components_home__["a" /* default */],
        meta: { requiresAuth: false, providerAuth: false, patientAuth: false }
    }, {
        path: '/about',
        name: 'About',
        component: __WEBPACK_IMPORTED_MODULE_6__components_about__["a" /* default */],
        meta: { requiresAuth: false, providerAuth: false, patientAuth: false }
    }, {
        path: '/contact',
        name: 'Contact',
        component: __WEBPACK_IMPORTED_MODULE_7__components_contact__["a" /* default */],
        meta: { requiresAuth: false, providerAuth: false, patientAuth: false }
    }, {
        path: '/account/signin',
        name: 'Signin',
        component: __WEBPACK_IMPORTED_MODULE_8__components_account_signin__["a" /* default */],
        meta: { requiresAuth: false, providerAuth: false, patientAuth: false }
    }, {
        path: '/account/signup',
        name: 'Signup',
        component: __WEBPACK_IMPORTED_MODULE_9__components_account_signup__["a" /* default */],
        meta: { requiresAuth: false, providerAuth: false, patientAuth: false }
    }, {
        path: '/patient/forgot-password',
        name: 'PatientForgotPassword',
        component: __WEBPACK_IMPORTED_MODULE_11__components_patient_patient_forgot_password__["a" /* default */],
        meta: { requiresAuth: false, providerAuth: false, patientAuth: false }
    }, {
        path: '/patient/welcome',
        name: 'PatientWelcome',
        component: __WEBPACK_IMPORTED_MODULE_10__components_patient_patient_welcome__["a" /* default */],
        meta: { requiresAuth: true, providerAuth: false, patientAuth: true }
    }, {
        path: '/provider/forgot-password',
        name: 'ProviderForgotPassword',
        component: __WEBPACK_IMPORTED_MODULE_13__components_provider_provider_forgot_password__["a" /* default */],
        meta: { requiresAuth: false, providerAuth: false, patientAuth: false }
    }, {
        path: '/provider/change-password',
        name: 'ProviderChangePassword',
        component: __WEBPACK_IMPORTED_MODULE_14__components_provider_provider_change_password__["a" /* default */],
        meta: { requiresAuth: true, providerAuth: true, patientAuth: false }
    }, {
        path: '/provider/welcome',
        name: 'ProviderWelcome',
        component: __WEBPACK_IMPORTED_MODULE_12__components_provider_provider_welcome__["a" /* default */],
        meta: { requiresAuth: true, providerAuth: true, patientAuth: false }
    }]
});

router.beforeEach(function (to, from, next) {
    if (to.meta.requiresAuth) {
        var accessToken = {};
        var userInfo = __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.getJSON('meta-user');
        if (userInfo != null && userInfo.tokens != null) {
            if (to.meta.providerAuth) {
                if (userInfo.type.toLowerCase() === "provider") accessToken = userInfo.tokens.accessToken;
            } else if (to.meta.patientAuth) {
                if (userInfo.type.toLowerCase() === "patient") accessToken = userInfo.tokens.accessToken;
            }
        }

        var now = new Date();
        var access = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(accessToken);
        if (access != null) {
            if (now.getMilliseconds() < access.exp) {
                next();
            } else {
                next('/account/signin');
            }
        }
    } else {
        next();
    }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "e6KS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome-patient-page"},[_c('h1',[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fcFS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_input__ = __webpack_require__("qRo1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_input__["a" /* default */]);

/***/ }),

/***/ "fkJA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"patient-forgot-page"},[_c('b-container',[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('h2',[_vm._v("Patient Forgot Password")])])],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('p',[_vm._v(_vm._s(_vm.message))])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hs8C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jgXw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-page"},[_c('h1',[_vm._v("About")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kJiG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_file__ = __webpack_require__("9NuQ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_file__["a" /* default */]);

/***/ }),

/***/ "lDJJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_provider_forgot_password_vue__ = __webpack_require__("vIAr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_760361d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_provider_forgot_password_vue__ = __webpack_require__("Vo8g");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_provider_forgot_password_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_760361d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_provider_forgot_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "olkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user_js__ = __webpack_require__("DxRk");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        user: {
            isAuthenticated: __WEBPACK_IMPORTED_MODULE_2__user_js__["a" /* default */].isAuthenticated(), //false,
            username: __WEBPACK_IMPORTED_MODULE_2__user_js__["a" /* default */].getUsername(), //'',
            longUsername: __WEBPACK_IMPORTED_MODULE_2__user_js__["a" /* default */].getLongUsername() //''
        }
    },
    actions: {},
    mutations: {},
    getters: {},
    modules: {}
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "olo0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome-provider-page"},[_c('h1',[_vm._v(_vm._s(_vm.message))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r15W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__("xKc6");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("utR/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rM6t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_main_menu__ = __webpack_require__("NjTB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_js__ = __webpack_require__("cHtD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_js__ = __webpack_require__("olkN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_js__ = __webpack_require__("DxRk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$http = __WEBPACK_IMPORTED_MODULE_5_axios___default.a;
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype.$user = __WEBPACK_IMPORTED_MODULE_4__user_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Application',
    router: __WEBPACK_IMPORTED_MODULE_2__router_js__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_3__store_js__["a" /* default */],
    components: {
        MainMenu: __WEBPACK_IMPORTED_MODULE_0__components_main_menu__["a" /* default */]
    },
    beforeCreated: onBeforeCreate,
    created: onCreated,
    beforeMount: onBeforeMount,
    mounted: onMounted,
    beforeUpdate: onBeforeUpdate,
    updated: onUpdated,
    beforeDestroy: onBeforeDestroy,
    destroyed: onDestroyed,
    render: onRender
});

function onBeforeMount() {
    console.log('application onBeforeMount');
}

function onMounted() {
    console.log('application onMounted.');
}

function onCreated() {
    console.log('application onCreated.');
}

function onBeforeCreate() {
    console.log('application onBeforeCreate.');
}

function onBeforeUpdate() {
    console.log('application onBeforeUpdate');
}

function onUpdated() {
    console.log('application onUpdated');
}

function onBeforeDestroy() {
    console.log('application onBeforeDestroy');
}

function onDestroyed() {
    console.log('application onDestroyed');
}

function onRender() {
    console.log('application onRender.');
}

/***/ }),

/***/ "rXWU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_application_vue__ = __webpack_require__("rM6t");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9118f4fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_application_vue__ = __webpack_require__("y61R");
function injectStyle (ssrContext) {
  __webpack_require__("0T8p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_application_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9118f4fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_application_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tSoY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"provider-change-password-page"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-form',{on:{"submit":_vm.onSubmitChangePassword}},[_c('b-container',[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('h2',[_vm._v("Provider Change Password")])])],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"id":"change-password-old-password-group","label-for":"change-password-old-password-input","label":"Old Password:"}},[_c('b-form-input',{attrs:{"id":"change-password-old-password-input","type":"password","placeholder":"Old Password"},model:{value:(_vm.form.oldPassword),callback:function ($$v) {_vm.$set(_vm.form, "oldPassword", $$v)},expression:"form.oldPassword"}})],1)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"id":"change-password-password-group","label-for":"change-password-password-input","label":"Password:"}},[_c('b-form-input',{attrs:{"id":"change-password-password-input","type":"password","placeholder":"New Password"},model:{value:(_vm.form.newPassword),callback:function ($$v) {_vm.$set(_vm.form, "newPassword", $$v)},expression:"form.newPassword"}})],1)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-group',{attrs:{"id":"change-password-confirm-password-group","label-for":"change-password-confirm-password-input","label":"Confirm Password:"}},[_c('b-form-input',{attrs:{"id":"change-password-confirm-password-input","type":"password","placeholder":"Confirm New Password"},model:{value:(_vm.form.confirmNewPassword),callback:function ($$v) {_vm.$set(_vm.form, "confirmNewPassword", $$v)},expression:"form.confirmNewPassword"}})],1)],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v("Submit")])],1)],1),_vm._v(" "),_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"6"}},[_vm._v("\n                    "+_vm._s(_vm.message)+"\n                ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "utR/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vIAr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_js__ = __webpack_require__("DxRk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Provider-Forgot-Password',
    data: function data() {
        return {
            message: "",
            form: {
                username: "",
                verficationCode: "",
                password: "",
                confirmPassword: ""
            }
        };
    },

    methods: {
        onSendVerificationCode: onSendVerificationCode,
        onSubmitForgotPassword: onSubmitForgotPassword
    }

    ////////////////////////////////////////////////////////////////////////////////
    //
    //
    //
});function onSendVerificationCode(event) {
    var hasError = false;
    if (this.form.username === undefined || this.form.username.length <= 0) {
        this.message = "Please fill out the username\n";
        hasError = true;
    }

    if (hasError) return;

    var _this = this;
    __WEBPACK_IMPORTED_MODULE_0__user_js__["a" /* default */].forgotPassword(this.form.username, __WEBPACK_IMPORTED_MODULE_0__user_js__["a" /* default */].UserEnum.PROVIDER, function successCallback() {
        _this.message = "Please check the associated email for a confirmation number";
    }, function failureCallback(error) {
        _this.message = "An error occurred attempting to send a confirmation code";
        hasError = true;
    });
}

////////////////////////////////////////////////////////////////////////////////
//
//
//
function onSubmitForgotPassword(event) {
    var _this = this;
    var hasError = false;
    if (this.form.password === undefined || this.form.password.length <= 0) {
        this.message = "Please fill out the password\n";
        hasError = true;
    }

    if (this.form.username === undefined || this.form.username.length <= 0) {
        this.message = "Please fill out the username\n";
        hasError = true;
    }

    if (this.form.verficationCode === undefined || this.form.verficationCode.length <= 0) {
        this.message = "Please fill out the verification code\n";
        hasError = true;
    }

    if (this.form.password !== this.form.confirmPassword) {
        this.message = "The passwords do not match.";
        hasError = true;
    }

    if (hasError) return;

    __WEBPACK_IMPORTED_MODULE_0__user_js__["a" /* default */].confirmPassword(this.form.username, this.form.password, this.form.verficationCode, __WEBPACK_IMPORTED_MODULE_0__user_js__["a" /* default */].UserEnum.PROVIDER, function successCallback() {
        _this.$router.push('/account/signin');
    }, function failureCallback(error) {
        _this.message = "An error occurred attempting to update the provider password.";
    });
}

/***/ }),

/***/ "vTH8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user_js__ = __webpack_require__("DxRk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Provider-Signup',
    data: function data() {
        return {
            signedUp: false,
            form: {
                selectedCountry: null,
                givenName: null,
                familyName: null,
                companyName: null,
                email: null,
                phone: null,
                password: null,
                countries: [{ value: null, text: "Select one", abbreviation: "" }, { value: 0, text: "United States", abbreviation: "US" }, { value: 1, text: "Canada", abbreviation: "CA" }]
            }
        };
    },

    methods: {
        onSubmit: onSubmit
    },
    mounted: onMounted

    ////////////////////////////////////////////////////////////////////////////////
    //
    //
    //
});function onSubmit(event) {
    var recaptchaResponse = grecaptcha.getResponse(this.recaptchaID);
    if (recaptchaResponse.length === 0) {
        alert("Please verify that you're a human");
        return;
    }

    var _this = this;
    __WEBPACK_IMPORTED_MODULE_0__user_js__["a" /* default */].signUp({
        username: _this.form.email,
        password: _this.form.password
    }, {
        recaptchaResponse: recaptchaResponse,
        userType: __WEBPACK_IMPORTED_MODULE_0__user_js__["a" /* default */].UserEnum.PROVIDER,
        attributes: [{
            "key": "given_name",
            "value": _this.form.givenName
        }, {
            "key": "family_name",
            "value": _this.form.familyName
        }, {
            "key": "phone_number",
            "value": _this.form.phone
        }, {
            "key": "email",
            "value": _this.form.email
        }]
    }, function (response) {
        alert('Signup provider success.');
        _this.signedUp = true;
    }, function (error) {
        alert('Signup provider failure');
        if (typeof error.response.data.error.code != 'undefined') {
            switch (error.response.data.error.code) {
                case "UserNotConfirmedException":
                    break;
            }
        } else {
            alert('An error has occurred while attempting to sign up.');
        }
    });
}

////////////////////////////////////////////////////////////////////////////////
//
//
//
function onMounted() {
    this.recaptchaID = grecaptcha.render("provider-recaptcha", {
        sitekey: "6LdxaU0UAAAAAB9Dy583J6VbH4BNn8PTvvk9ikJ9"
    });
}

/***/ }),

/***/ "wUZA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("FGQs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b170699c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("bGp9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b170699c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xKc6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress__ = __webpack_require__("E9Zr");
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__progress__["a" /* default */]);

/***/ }),

/***/ "xcyk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signin_vue__ = __webpack_require__("/FRj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d4277a1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signin_vue__ = __webpack_require__("adTx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d4277a1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_signin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y61R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"application"}},[_c('main-menu'),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zRCK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__ = __webpack_require__("UJfa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1df4fad0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__ = __webpack_require__("jgXw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1df4fad0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zjWa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-page"},[_c('h1',[_vm._v("Contact")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.933a00498786f86ec558.js